import {
  Box,
  Button,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useErrorHandler from "../../hooks/useErrorHandler";
import useSnackbar from "../../hooks/useSnackbar";
const emptyPaymentData = {
  email: "",
  amount: "",
};
export default function PaymentForm() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();

  const { data: user } = useSelector((state) => state.user);

  const [paymentData, setPaymentData] = useState(emptyPaymentData);

  const onInputChange = ({ target }) => {
    setPaymentData((prev) => ({ ...prev, [target.name]: target.value }));
  };

  const onCreateFormSubmit = async (e) => {
    e.preventDefault();
    try {
      //   await createUser(user.token, userData);
      snackbar.showSuccess();
      navigate("/users");
    } catch (err) {
      handleError(err);
      // snackbar.showError();
    }
  };
  return (
    <>
      <Box mb={2} display="flex" justifyContent="flex-end">
        <Link to="/">
          <Button variant="contained" size="small" color="secondary" className="black-border-button">
            Cancel
          </Button>
        </Link>
      </Box>
      <Paper elevation={3}>
        <Box p={2}>
          <Typography>Payment of ODR</Typography>
        </Box>
        <Box px={2} pb={2} component="form" onSubmit={onCreateFormSubmit}>
          <Grid marginBottom={2.5} container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Email"
                name="email"
                value={paymentData.email}
              />
            </Grid>
          </Grid>
          <Grid marginBottom={2.5} container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Amount($)"
                name="amount"
                value={paymentData.amount}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg="auto">
            <Button size="small" variant="contained" type="submit">
              Submit
            </Button>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}
